import { gql } from "@apollo/client"
import { PaymentsSettingsUpdateInput, Company } from "@oysterhr/schema"
import { useMutation } from "@oysterhr/core"

export const MUTATION = gql`
  mutation StaffInvoicingPaymentStatusUpdateRestricted(
    $companyId: ID!
    $restricted: Boolean
    $flaggedAsFraudster: Boolean
    $flaggedAsFraudsterReason: String
    $restrictedReason: String
    $automaticallyRemoveRestriction: Boolean
  ) {
    updatePaymentsSettings(
      input: {
        companyId: $companyId
        restricted: $restricted
        restrictedReason: $restrictedReason
        flaggedAsFraudster: $flaggedAsFraudster
        flaggedAsFraudsterReason: $flaggedAsFraudsterReason
        automaticallyRemoveRestriction: $automaticallyRemoveRestriction
      }
    ) {
      company {
        id
      }
      errors
    }
  }
`

type MutationArgs = Pick<
  PaymentsSettingsUpdateInput,
  | "restricted"
  | "restrictedReason"
  | "flaggedAsFraudster"
  | "flaggedAsFraudsterReason"
  | "automaticallyRemoveRestriction"
  | "companyId"
>
type MutationResult = {
  updatePaymentsSettings: {
    company: Pick<Company, "id">
    errors: string[]
  }
}

export const useUpdatePaymentSettings = () =>
  useMutation<MutationResult, MutationArgs>(MUTATION, {
    handlePayloadErrors: true,
  })
